import { IMAGE_BASE } from './site';

export const SERVICES = [
  {
    title: 'Road paint repair',
    description: 'Revitalize roads with expert paint repair for a smooth, safe journey.',
    image: `${IMAGE_BASE}/img21.jpg`,
    link: '/solutions',
  },
  {
    title: 'Advertising media signs',
    description: 'Elevate your business visibility with impactful advertising media signs.',
    image: `${IMAGE_BASE}/img22.jpg`,
    link: '/solutions',
  },
  {
    title: 'Aluminum signs',
    description:
      'Durable aluminum signs with weather-resistant finishes for long-lasting visibility.',
    image: `${IMAGE_BASE}/img23.jpg`,
    link: '/solutions',
  },
  {
    title: 'Made-to-order signs',
    description: 'Custom signage tailored to your specifications for a standout impact.',
    image: `${IMAGE_BASE}/img25.jpg`,
    link: '/solutions',
  },
];
